import { lazy, FC, Suspense } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

import ScreenLoader from "components/ScreenLoader/ScreenLoader";
import ScrollToTop from "modules/partials/ScrollToTop";
import { RootState } from "store";

const AccountLocked = lazy(() => import("components/AccountLocked/AccountLocked"));

const AppShellLayout: FC = () => {
  const locked = useSelector((state: RootState) => state.account.locked);

  if (locked) {
    return (
      <Suspense fallback={<ScreenLoader />}>
        <AccountLocked />
      </Suspense>
    );
  }

  return (
    <ScrollToTop>
      <Outlet />
    </ScrollToTop>
  );
};

export default AppShellLayout;
